/**
 * Полоса учебного режима между шапкой и содержимым (E4.5): учебный контур всегда заметен,
 * отсюда же пример начинается заново (после подтверждения: сброс стирает разборы и учебные
 * политики) и закрывается возвратом к работе.
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmModal } from '@/components/ConfirmModal';
import { WorkspaceIcon } from '@/components/workspace/WorkspaceIcon';
import { useWorkspaceDataSource } from '@/features/workspace/WorkspaceDataSourceContext';
import { restartUnfinishedExercises } from './progress';
import { useTrainingProgress } from './useTrainingProgress';

export function TrainingBanner() {
	const { t } = useTranslation('common');
	const { mode, exitTraining, resetTraining } = useWorkspaceDataSource();
	const { update } = useTrainingProgress();
	const [resetting, setResetting] = useState(false);
	const [resetFailed, setResetFailed] = useState(false);
	const [confirming, setConfirming] = useState(false);

	if (mode === 'live') return null;

	const reset = () => {
		setConfirming(false);
		setResetting(true);
		setResetFailed(false);
		resetTraining()
			/* Состояние примера исходное: цели незавершённых заданий в нём больше не выполнены */
			.then(() => update(restartUnfinishedExercises))
			.catch(() => setResetFailed(true))
			.finally(() => setResetting(false));
	};

	return (
		<section className="ws-training-banner" aria-label={t('training.banner.label')}>
			<WorkspaceIcon name="report" size={16} />
			<p>
				<strong>{t('training.banner.title')}</strong>
				<span>{t('training.banner.hint')}</span>
				{resetFailed && <span role="alert">{t('training.banner.resetFailed')}</span>}
			</p>
			<div className="ws-training-banner-actions">
				<button
					type="button"
					className="ws-btn ws-subtle"
					onClick={() => setConfirming(true)}
					disabled={resetting}
				>
					{t('training.banner.reset')}
				</button>
				<button type="button" className="ws-btn ws-primary" onClick={() => exitTraining()}>
					{t('training.banner.exit')}
				</button>
			</div>
			<ConfirmModal
				open={confirming}
				title={t('training.banner.resetConfirm.title')}
				description={t('training.banner.resetConfirm.description')}
				confirmLabel={t('training.banner.resetConfirm.confirm')}
				cancelLabel={t('training.banner.resetConfirm.cancel')}
				danger
				onConfirm={reset}
				onCancel={() => setConfirming(false)}
			/>
		</section>
	);
}
